import React, { useEffect, useState } from 'react';
import useGetURL from '../hooks/useGetURL';
import styles from './Totales.module.css';

const Totales = () => {
  const [totales, setTotales] = useState(null);
  const { isCargando, fetchData, resetErroresGet } = useGetURL();

  useEffect(() => {
    resetErroresGet();
  }, [resetErroresGet]);

  useEffect(() => {
    fetchData('totales', setTotales);
  }, [fetchData]);

  return (
    <React.Fragment>
      {totales && !isCargando && (
        <table className={`${styles.tablaTotales}`}>
          <tbody>
            <tr>
              <td className={`${styles.total}`}>{totales.personas}</td>
              <td className={`${styles.detalle}`}>personas</td>
            </tr>
            <tr>
              <td></td>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td className={`${styles.total}`}>{totales.jugadores}</td>
                      <td className={`${styles.detalle}`}>jugadores</td>
                    </tr>
                    <tr>
                      <td className={`${styles.total}`}>{totales.tecnicos}</td>
                      <td className={`${styles.detalle}`}>técnicos</td>
                    </tr>
                    <tr>
                      <td className={`${styles.total}`}>{totales.arbitros}</td>
                      <td className={`${styles.detalle}`}>árbitros</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td className={`${styles.total}`}>{totales.clubes}</td>
              <td className={`${styles.detalle}`}>clubes</td>
            </tr>
            <tr>
              <td className={`${styles.total}`}>{totales.equipos}</td>
              <td className={`${styles.detalle}`}>equipos</td>
            </tr>
            <tr>
              <td className={`${styles.total}`}>{totales.estadios}</td>
              <td className={`${styles.detalle}`}>estadios</td>
            </tr>
            <tr>
              <td className={`${styles.total}`}>{totales.partidos}</td>
              <td className={`${styles.detalle}`}>partidos</td>
            </tr>
          </tbody>
        </table>
      )}
    </React.Fragment>
  );
};

export default Totales;
